import { useState } from "react";

import { type ConnectionType } from "@north-beam/nb-client-side/nb-api-graphql-generated/global-types";
import { type AccountValidationInfo } from "@north-beam/nb-common/constants";
import { PrimaryButton } from "@shared/buttons";

import ConnectionStatusManager, {
  type LoginComponentChildrenProps,
} from "./connection-status-manager";

type AddAdditionalPrimaryAccountProps = {
  connectionType: ConnectionType;
  connectedAccounts: AccountValidationInfo[];
  children: (props: LoginComponentChildrenProps) => React.ReactNode;
};

export const AddAdditionalPrimaryAccount = ({
  connectionType,
  connectedAccounts,
  children,
}: AddAdditionalPrimaryAccountProps) => {
  const [isAddingAdditionalAccount, setIsAddingAdditionalAccount] =
    useState(false);
  return (
    <>
      {!isAddingAdditionalAccount && (
        <PrimaryButton onClick={() => setIsAddingAdditionalAccount(true)}>
          <i className="fa-solid fa-plus mr-1"></i> Add Account
        </PrimaryButton>
      )}
      {isAddingAdditionalAccount && (
        <ConnectionStatusManager
          id={null}
          type={connectionType}
          accounts={connectedAccounts}
          onSuccessfulUpserting={() => setIsAddingAdditionalAccount(false)}
        >
          {children}
        </ConnectionStatusManager>
      )}
    </>
  );
};
